import medicoreLogoSmall from './assets/adapters/medicore-logo-small.png'
import nedapLogo from './assets/adapters/nedap-ons-logo.svg'
import sdbLogo from './assets/adapters/sdb-logo.svg'

export enum EHRAdapter {
    MEDICORE = 1,
    SDBUSER = 2,
    NEDAP = 3,
}

export const EHRAdapterMap: Record<number, string> = {
    [EHRAdapter.MEDICORE]: 'medicore',
    [EHRAdapter.SDBUSER]: 'sdbuser',
    [EHRAdapter.NEDAP]: 'nedap',
}
export const EHRAdapterLogoMap: Record<number, string> = {
    [EHRAdapter.MEDICORE]: medicoreLogoSmall,
    [EHRAdapter.SDBUSER]: sdbLogo,
    [EHRAdapter.NEDAP]: nedapLogo,
}

export const EHRAdapterDisplayNameMap: Record<string, string> = {
    medicore: 'Medicore',
    sdbuser: 'SDB User',
    nedap: 'Nedap ONS',
}

export interface AdapterCapabilities {
    requiresPatientFirst: boolean
    /**
     * A launch patient is resolved through GET /adapters/{name}/patients/{id} (MD-1452). It is on only
     * where that read is limited to what the caller may see: Medicore authorises it itself, and Nedap
     * resolves within the employee's caseload, taking the Ons client number rather than the Ons id it
     * returns (MD-1825). SDB has the endpoint, but its read skips the practitioner filter until OIDC
     * lands (MD-1484), so it stays off.
     */
    supportsPatientLookup: boolean
    /**
     * The patient search matches the client number as well as the name (MD-1772). Nedap and SDB match any
     * part of it and Medicore only the whole code, so the hint asks for the full number.
     */
    searchesByClientNumber: boolean
}

export const EHRAdapterCapabilities: Record<string, AdapterCapabilities> = {
    medicore: { requiresPatientFirst: false, supportsPatientLookup: true, searchesByClientNumber: true },
    sdbuser: { requiresPatientFirst: true, supportsPatientLookup: false, searchesByClientNumber: true },
    nedap: { requiresPatientFirst: false, supportsPatientLookup: true, searchesByClientNumber: true },
}

const defaultCapabilities: AdapterCapabilities = {
    requiresPatientFirst: false,
    supportsPatientLookup: false,
    searchesByClientNumber: false,
}

// Single resolution point for adapter identity/capabilities. When the manifest
// framework lands (see EHR Integration Framework design doc), these read from
// the fetched manifest instead of the static maps above.
export const getAdapterName = (ehrAdapter?: number | null): string | null =>
    ehrAdapter ? (EHRAdapterMap[ehrAdapter] ?? null) : null

export const getAdapterCapabilities = (ehrAdapter?: number | null): AdapterCapabilities => {
    const name = getAdapterName(ehrAdapter)
    return (name && EHRAdapterCapabilities[name]) || defaultCapabilities
}
